import { render, staticRenderFns } from "./version.vue?vue&type=template&id=02bac7ee&scoped=true"
import script from "./version.vue?vue&type=script&lang=js"
export * from "./version.vue?vue&type=script&lang=js"
import style0 from "./version.vue?vue&type=style&index=0&id=02bac7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bac7ee",
  null
  
)

export default component.exports